export interface RoutingType {
    id?: string;
    queueId: string;
    routingType: QueueRoutingType;
}

export enum QueueRoutingType {
    LastAgentRouting = 0,
    PreferredAgentRouting = 1,
    SkillBasedRouting = 2
}